import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/SearchPagesInternalResource.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/pages`;
	}
	listSearchPagesByProjectId(e) {
		return this.api.get(this.buildPath(`${n.baseUrl}/project/id`, { projectid: e }));
	}
};
//#endregion
export { n as SearchPagesInternalResource };

//# sourceMappingURL=SearchPagesInternalResource.js.map